import 'babel-core/polyfill';
import ReactDOM from 'react-dom';
import configureStore from '../configureStore';
import foundationReducer from '../screens/Foundation/reducers';
import { createRootReducer } from '../reducers/';
import createRootRouter from '../createRootRouter';
import foundationRouter from '../screens/Foundation/router';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-select/dist/react-select.css';
import 'font-awesome/css/font-awesome.css';
import 'stylesheets/basic.css';
import 'stylesheets/layout.css';
import { locationOrigin } from 'utils/';
if (!window.Intl) {
  require('intl');
}
if (!window.location.origin) {
  locationOrigin();
}

const reducer = createRootReducer('foundation', foundationReducer);
const store = configureStore(reducer, 'Foundation');
const rootRouter = createRootRouter(store, foundationRouter);

ReactDOM.render(rootRouter, document.getElementById('root'));



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/entrys/foundationEntry.js
 **/